import { getUrl } from '@glow/shared/lib/routes';
import { type LinkWithTitle } from '@glow/shared/utils/types';

export const additionalLinks: LinkWithTitle[] = [
  {
    title: 'Страница для клиентов',
    link: getUrl('clientLanding'),
  },
  {
    title: 'Страница для мастеров',
    link: getUrl('masterLanding'),
  },
  {
    title: 'Помощь в регистрации',
    link: getUrl('masterRegisterHelpLanding'),
  },
  {
    title: 'Блог',
    link: getUrl('blogPosts'),
  },
];
